import React from 'react';


const JobsSettingCard = ({ title, text, jobData, workType = "", workSettings = "" }: { title: string, text: any, jobData?: any, workType?: string, workSettings?: string }) => {
    return (
        <div className='h-[100%]  p-2 pl-5 bg-white rounded-lg py-3 px-3'>
            <div className=' w-12 h-12 rounded-full bg-gray-100 p-3 ml-[-5px]'>
                <img src="/images/jobdetail-vectore.png" alt="img" />
            </div>
            <div className='mt-4'>
                <p className='text-sm text-instant-teams-teal-L1 font-light'>
                    {title}
                </p>
                <p className='text-lg mt-2 font-semibold text-instant-teams-teal-Main'>{text}</p>
                {workType === "part_time" && <p className=' text-instant-teams-teal-Main text-xs '>{`${jobData?.hoursPerWeek.min} - ${jobData?.hoursPerWeek.max} hours/week`}</p>}
                {workSettings === "hybrid" && jobData?.hybridJobLocation && (
                    <div className="relative group max-w-full ">
                        <p
                            className="text-instant-teams-blue-Main text-xs truncate cursor-context-menu max-w-full"
                        >
                            {jobData?.hybridJobLocation.length > 15
                                ? jobData?.hybridJobLocation.slice(0, 15) + "..."
                                : jobData?.hybridJobLocation}
                        </p>

                        {/* Tooltip */}
                        <div className="absolute z-10 w-max max-w-xs bg-[#f9f6f6] shadow-lg text-black text-xs rounded-md px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none left-1/2 -translate-x-1/2 top-full mt-1">
                            {jobData?.hybridJobLocation}
                        </div>
                    </div>
                )}

            </div>

        </div>
    );
}

export default JobsSettingCard;

